import { render, staticRenderFns } from "./GestioneFiltri.vue?vue&type=template&id=99d3f4ca&"
import script from "./GestioneFiltri.vue?vue&type=script&lang=js&"
export * from "./GestioneFiltri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports